import { ErrorCode } from './graphql';

// Thrown by standard create/update hooks for app-level GraphQL errors.
// Preserves the structured error code so callers can match on it
// instead of parsing the message string.
export class GraphQLAppError extends Error {
  readonly code?: ErrorCode;

  constructor(message: string, code?: ErrorCode) {
    super(message);
    this.name = 'GraphQLAppError';
    this.code = code;
  }
}

export const isNotFoundError = (
  error: Error | null | undefined,
): error is GraphQLAppError =>
  error instanceof GraphQLAppError && error.code === ErrorCode.NotFound;
